import React, { useState } from 'react';
import { BellIcon, SearchIcon, LogOutIcon, SettingsIcon, HomeIcon, CoinsIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
interface AdminHeaderProps {
  onMenuClick: () => void;
}
export function AdminHeader({
  onMenuClick
}: AdminHeaderProps) {
  const {
    logout
  } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  return <header className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow border-b border-[#E0E0E0]" data-id="element-73">
      <button type="button" className="px-4 border-r border-[#E0E0E0] text-[#2A2A2A] md:hidden" onClick={onMenuClick} data-id="element-74">
        <span className="sr-only" data-id="element-75">Apri menu</span>
        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-76">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-77" />
        </svg>
      </button>
      <div className="flex-1 px-4 flex justify-between" data-id="element-78">
        <div className="flex-1 flex" data-id="element-79">
          <div className="w-full flex md:ml-0" data-id="element-80">
            <label htmlFor="search-field" className="sr-only" data-id="element-81">
              Cerca
            </label>
            <div className="relative w-full text-gray-400 focus-within:text-gray-600" data-id="element-82">
              <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none" data-id="element-83">
                <SearchIcon className="h-5 w-5" aria-hidden="true" data-id="element-84" />
              </div>
              <input id="search-field" className="block w-full h-full pl-8 pr-3 py-2 border-transparent bg-white text-[#2A2A2A] placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm" placeholder="Cerca cliente, utente, pratica..." type="search" data-id="element-85" />
            </div>
          </div>
        </div>
        <div className="ml-4 flex items-center md:ml-6" data-id="element-86">
          {/* Credits indicator */}
          <div className="flex items-center mr-4 bg-blue-50 px-3 py-1 rounded-full" data-id="element-87">
            <CoinsIcon className="h-4 w-4 text-[#1A3E5C] mr-1" data-id="element-88" />
            <span className="text-sm font-medium text-[#1A3E5C]" data-id="element-89">
              125 crediti
            </span>
          </div>
          {/* Notification dropdown */}
          <button type="button" className="ml-3 bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D5A85]" data-id="element-90">
            <span className="sr-only" data-id="element-91">Visualizza notifiche</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" data-id="element-92" />
          </button>
          {/* Profile dropdown */}
          <div className="ml-3 relative" data-id="element-93">
            <button type="button" className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2D5A85]" onClick={() => setShowUserMenu(!showUserMenu)} data-id="element-94">
              <span className="sr-only" data-id="element-95">Apri menu utente</span>
              <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden" data-id="element-96">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4FCizwzsrXpd7oSKvMhBGd/1555726299065.jpg" alt="Profile" className="h-8 w-8 object-cover" data-id="element-97" />
              </div>
            </button>
            {showUserMenu && <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-black ring-1 ring-opacity-5 focus:outline-none" data-id="element-98">
                <Link to="/" className="block px-4 py-2 text-sm text-[#2A2A2A] hover:bg-gray-100" onClick={() => setShowUserMenu(false)} data-id="element-99">
                  <div className="flex items-center" data-id="element-100">
                    <HomeIcon className="h-4 w-4 mr-2" data-id="element-101" />
                    Torna a CashFirst
                  </div>
                </Link>
                <Link to="/impostazioni-utente" className="block px-4 py-2 text-sm text-[#2A2A2A] hover:bg-gray-100" onClick={() => setShowUserMenu(false)} data-id="element-102">
                  <div className="flex items-center" data-id="element-103">
                    <SettingsIcon className="h-4 w-4 mr-2" data-id="element-104" />
                    Impostazioni
                  </div>
                </Link>
                <button onClick={() => {
              setShowUserMenu(false);
              logout();
            }} className="block w-full text-left px-4 py-2 text-sm text-[#2A2A2A] hover:bg-gray-100" data-id="element-105">
                  <div className="flex items-center" data-id="element-106">
                    <LogOutIcon className="h-4 w-4 mr-2" data-id="element-107" />
                    Logout
                  </div>
                </button>
              </div>}
          </div>
        </div>
      </div>
    </header>;
}